import Avatar from "react-avatar"

export default Avatar
